import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppDispatch } from 'app/config/store';
import { getEntities as getAuthorities } from 'app/entities/authorities/authorities.reducer';
import React, { useEffect } from 'react';
import { Translate } from 'react-jhipster';
import { Button, Card, Col, Row } from 'reactstrap';
import { reset } from '../permissions/permissions.reducer';
import { PermissionsGrid } from './permissions-grid';
import RolesGrid from './roles-grid';

export type Role = Partial<{
  defaultRole: boolean;
  displayName: string;
  name: string;
  scope: string;
  systemRole: boolean;
}>;

export const Roles = () => {
  const dispatch = useAppDispatch();
  const [selectedRow, setSelectedRow] = React.useState<Role>({} as Role);
  const [isNew, setIsNew] = React.useState(false);

  useEffect(() => {
    dispatch(reset());
  }, []);

  return (
    <Card className="jh-card">
      {!isNew ? (
        <>
          <Row>
            <Col md="8">
              <h2 id="roles-heading" data-cy="RolesHeading" data-testid="roles-heading">
                <div className="d-flex justify-content-between">
                  <div>
                    <Translate contentKey="rainspotApp.roles.accessControl">Access Control</Translate>
                  </div>
                  <Button
                    onClick={() => {
                      setSelectedRow({});
                      setIsNew(true);
                    }}
                    className="btn btn-primary jh-create-entity ml-5"
                    id="linkEntity"
                    data-testid="create-role-button"
                    data-cy="entityCreateButton"
                  >
                    <FontAwesomeIcon icon="plus" />
                    &nbsp;
                    <Translate contentKey="rainspotApp.roles.newRole">New Role</Translate>
                  </Button>
                </div>
              </h2>
            </Col>
          </Row>

          <RolesGrid selectedRow={selectedRow} setSelectedRow={setSelectedRow} />
          {!!selectedRow?.name && (
            <>
              <div className="mt-10">&nbsp;</div>
              <h2 id="permissions-heading" data-cy="PermissionsHeading" data-testid="permissions-heading">
                <div className="d-flex justify-content-between mt-10">
                  <div>
                    <Translate contentKey="rainspotApp.roles.accessPermissions">Access Permissions</Translate>
                  </div>
                </div>
              </h2>
              <div className="mb-20">&nbsp;</div>
              <PermissionsGrid selectedRow={selectedRow} setSelectedRow={setSelectedRow} setIsNew={setIsNew} />
            </>
          )}
        </>
      ) : (
        <>
          <PermissionsGrid selectedRow={null} setSelectedRow={setSelectedRow} setIsNew={setIsNew} isNew={isNew} />
        </>
      )}
    </Card>
  );
};
